import React, { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import { useCarriereEvents } from "contexts/CarriereEventsContext";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import DropDown from "components/ui/controls/drop-down/drop-down";
import Row from "components/ui/layout/row/row";
import CheckBox from "components/ui/controls/check-box/check-box";
import { FaBuilding, FaDollarSign, FaUserTie, FaCalendarPlus, FaQuestionCircle } from "react-icons/fa";
import { CustomTooltip } from "components/ui/controls/custom-tooltip/custom-tooltip";
import { Button } from "@mui/material";
import { createStyledButton } from "components/ui/controls/button/button-styles";

const classe_retraiteCarpv = [
  {
    value: "SS1",
    label: "SS1",
  },
  {
    value: "SS2",
    label: "SS2",
  },
  {
    value: "S1",
    label: "S1",
  },
  {
    value: "S2",
    label: "S2",
  },
  {
    value: "A",
    label: "A",
  },
  {
    value: "B",
    label: "B",
  },
  {
    value: "C",
    label: "C",
  },
  {
    value: "D",
    label: "D",
  },
  {
    value: "E",
    label: "E",
  },
];
const ClasseRetraiteCnbf = [
  {
    value: "C1",
    label: "C1",
  },
  {
    value: "C2",
    label: "C2",
  },
  {
    value: "C2+",
    label: "C2+",
  },
];
const ClasseRetr = [
  {
    value: "NC",
    label: "NC",
  },
  {
    value: "A",
    label: "A",
  },
  {
    value: "B",
    label: "B",
  },
  {
    value: "C",
    label: "C",
  },
  {
    value: "D",
    label: "D",
  },
  {
    value: "E",
    label: "E",
  },
  {
    value: "F",
    label: "F",
  },
  {
    value: "G",
    label: "G",
  },
  {
    value: "H",
    label: "H",
  },
  {
    value: "I",
    label: "I",
  },
];
const Conventionne = [
  {
    value: "oui",
    label: "Oui",
  },
  {
    value: "non",
    label: "Non",
  },
];
const ConventionneCarmf = [
  {
    value: "non",
    label: "Non",
  },
  {
    value: "Secteur1",
    label: "Secteur 1",
  },
  {
    value: "Secteur2",
    label: "Secteur 2",
  },
];
const BiologisteConventionne = [
  {
    value: "oui",
    label: "Oui",
  },
  {
    value: "non",
    label: "Non",
  },
];
const CotisationCapi = [
  {
    value: "classe3",
    label: "3",
  },
  {
    value: "classe4",
    label: "4",
  },
  {
    value: "classe5",
    label: "5",
  },
  {
    value: "classe6",
    label: "6",
  },
  {
    value: "classe7",
    label: "7",
  },
  {
    value: "classe8",
    label: "8",
  },
  {
    value: "classe9",
    label: "9",
  },
  {
    value: "classe10",
    label: "10",
  },
  {
    value: "classe11",
    label: "11",
  },
  {
    value: "classe12",
    label: "12",
  },
  {
    value: "classe13",
    label: "13",
  },
];
const CategorieFonctionPublique = [
  {
    value: "sedentaire",
    label: "Sédentaire",
  },
  {
    value: "active",
    label: "Active",
  },
];

function Parametres(props) {
  const context = useContext(AppContext);
  const { trackEvent } = useCarriereEvents();

  let AnneeFinPeriode = 0;
  if (context.state.RetraiteDebutActivite.length === 8 && context.state.RetraiteFinActivite.length === 8) {
    AnneeFinPeriode = context.state.RetraiteFinActivite.slice(4);
  }

  // Déclencher l'événement avec le type d'activité au montage du composant
  useEffect(() => {
    if (context.state.RetraiteActivite) {
      trackEvent("PERIODE", "TAB_PARAMETRES", { activite: context.state.RetraiteActivite });
    }
  }, []);
  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            {(context.state.RetraiteActivite === "SalarieNonCadre" ||
              context.state.RetraiteActivite === "SalarieCadre" ||
              context.state.RetraiteActivite === "SalarieNonCadreCFE" ||
              context.state.RetraiteActivite === "SalarieCadreCFE" ||
              context.state.RetraiteActivite === "SalarieNonCadreAgricole" ||
              context.state.RetraiteActivite === "SalarieCadreAgricole" ||
              context.state.RetraiteActivite === "SalarieIrcantec" ||
              context.state.RetraiteActivite === "CavecSalarie" ||
              context.state.RetraiteActivite === "FonctionPublique") && (
              <Row>
                <Column>
                  <TextField
                    label="Taux d'activité"
                    value={context.state.TauxActivite}
                    onKeyUp={context.handleInputChange("TauxActivite")}
                    dataType="float"
                    format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                    normal
                  />
                </Column>
              </Row>
            )}

            {(context.state.RetraiteActivite === "SalarieNonCadre" ||
              context.state.RetraiteActivite === "SalarieCadre" ||
              context.state.RetraiteActivite === "SalarieNonCadreCFE" ||
              context.state.RetraiteActivite === "SalarieCadreCFE" ||
              context.state.RetraiteActivite === "SalarieNonCadreAgricole" ||
              context.state.RetraiteActivite === "SalarieCadreAgricole" ||
              context.state.RetraiteActivite === "CavecSalarie") && (
              <>
                <Row>
                  <div className="dossier-header">
                    <div className="dossier-header-icon">
                      <FaBuilding style={{ color: "#6b7280", fontSize: "16px" }} />
                    </div>
                    <span className="dossier-header-title">Cotisations retraite AGIRC ARRCO</span>
                  </div>
                </Row>
                {(context.state.RetraiteActivite === "SalarieNonCadreCFE" || context.state.RetraiteActivite === "SalarieCadreCFE") && (
                  <Row tpad>
                    <Column>
                      <DropDown
                        label="Affiliation AGIRC-ARRCO"
                        value={context.state.CFEAgircArrco}
                        onChange={context.handleInputChange("CFEAgircArrco")}
                        options={[
                          { value: "Oui", label: "Oui" },
                          { value: "Non", label: "Non" },
                        ]}
                        normal
                      />
                    </Column>
                  </Row>
                )}
                {(context.state.RetraiteActivite === "SalarieNonCadre" ||
                  context.state.RetraiteActivite === "SalarieCadre" ||
                  (context.state.RetraiteActivite === "SalarieNonCadreCFE" && context.state.CFEAgircArrco === "Oui") ||
                  (context.state.RetraiteActivite === "SalarieCadreCFE" && context.state.CFEAgircArrco === "Oui") ||
                  context.state.RetraiteActivite === "SalarieNonCadreAgricole" ||
                  context.state.RetraiteActivite === "SalarieCadreAgricole" ||
                  context.state.RetraiteActivite === "CavecSalarie") && (
                  <Row tpad>
                    <Column>
                      <div className="prise-en-charge-container">
                        <div className="prise-en-charge-table-container">
                          <table className="mono">
                            <tbody>
                              <tr>
                                <td></td>
                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                  <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                    Salarié
                                  </label>
                                </td>
                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                  <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                    Patronale
                                  </label>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "middle", marginBottom: 0 }}>
                                  <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                    Tranche 1
                                  </label>
                                </td>
                                <td>
                                  <TextField
                                    value={context.state.ParamCotisations["AgircArrcoT1Sal"]}
                                    onChange={context.handleParametrePeriode("AgircArrcoT1Sal")}
                                    dataType="ufloat"
                                    format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                    normal
                                    style={{ textAlign: "center" }}
                                  />
                                </td>
                                <td>
                                  <TextField
                                    value={context.state.ParamCotisations["AgircArrcoT1Pat"]}
                                    onChange={context.handleParametrePeriode("AgircArrcoT1Pat")}
                                    dataType="ufloat"
                                    format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                    normal
                                    style={{ textAlign: "center" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ verticalAlign: "middle", marginBottom: 0 }}>
                                  <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                    Tranche 2
                                  </label>
                                </td>
                                <td>
                                  <TextField
                                    value={context.state.ParamCotisations["AgircArrcoT2Sal"]}
                                    onChange={context.handleParametrePeriode("AgircArrcoT2Sal")}
                                    dataType="ufloat"
                                    format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                    normal
                                    style={{ textAlign: "center" }}
                                  />
                                </td>
                                <td>
                                  <TextField
                                    value={context.state.ParamCotisations["AgircArrcoT2Pat"]}
                                    onChange={context.handleParametrePeriode("AgircArrcoT2Pat")}
                                    dataType="ufloat"
                                    format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                    normal
                                    style={{ textAlign: "center" }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Column>
                  </Row>
                )}
              </>
            )}
            {context.state.RetraiteActivite === "Ircec" && (
              <>
                <Row>
                  <div className="dossier-header">
                    <div className="dossier-header-icon">
                      <FaBuilding style={{ color: "#6b7280", fontSize: "16px" }} />
                    </div>
                    <span className="dossier-header-title">Cotisations RAAP</span>
                  </div>
                </Row>
                <Row tpad>
                  <Column>
                    <DropDown
                      label="Affiliation volontaire"
                      value={context.state.ParamCotisations["AffiliationVolontaireRaap"]}
                      onChange={context.handleParametrePeriode("AffiliationVolontaireRaap")}
                      options={[
                        { value: "Oui", label: "Oui" },
                        { value: "Non", label: "Non" },
                      ]}
                      normal
                    />
                  </Column>
                  <Column>
                    <DropDown
                      label="Taux de cotisation"
                      value={context.state.ParamCotisations["TauxCotisationRaap"]}
                      onChange={context.handleParametrePeriode("TauxCotisationRaap")}
                      options={[
                        { value: "4", label: "4%" },
                        { value: "8", label: "8%" },
                      ]}
                      normal
                    />
                  </Column>
                </Row>
                <Row>
                  <div className="dossier-header">
                    <div className="dossier-header-icon">
                      <FaBuilding style={{ color: "#6b7280", fontSize: "16px" }} />
                    </div>
                    <span className="dossier-header-title">Cotisations RACL / RACD</span>
                  </div>
                </Row>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: 700,
                    margin: "8px 0 8px 0",
                    paddingLeft: 12,
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    fontSize: 12,
                    color: "#64748b",
                    fontWeight: 600,
                    letterSpacing: "-0.01em",
                  }}
                >
                  <span style={{ minWidth: 96, marginRight: 18, textAlign: "center" }}>Année</span>
                  <span style={{ width: 180, marginRight: 18, textAlign: "center", display: "inline-block" }}>Part des revenus RACL</span>
                  <span style={{ width: 180, marginRight: 18, textAlign: "center", display: "inline-block" }}>Part des revenus RACD</span>
                </div>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    width: "54%",
                    maxWidth: 700,
                    marginLeft: 0,
                    marginRight: 0,
                    display: "block",
                  }}
                >
                  {Object.keys(context.state.DetailRetraiteFutur).length > 0 &&
                    Object.keys(context.state.DetailRetraiteFutur)
                      .filter((Annee) => Number(Annee) >= context.state["TableauPoints" + props.ClientConjoint].AnneeFinRacdComp)
                      .map((Annee, index) => {
                        return (
                          <li
                            key={"Cavamac" + index}
                            style={{
                              background: "#fff",
                              borderRadius: "12px",
                              boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                              padding: "8px 0 8px 12px",
                              marginBottom: "14px",
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                              border: "1.5px solid #d1d5db",
                              transition: "box-shadow 0.2s",
                              width: "505px",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: 700,
                                fontSize: "12px",
                                color: " #6366f1",
                                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                                minWidth: 70,
                                marginRight: 18,
                                background: "#f1f5ff",
                                border: "1.5px solid #6366f1",
                                borderRadius: "8px",
                                padding: "4px 12px",
                                display: "inline-block",
                                textAlign: "center",
                              }}
                            >
                              {Annee}
                            </span>
                            <TextField
                              value={
                                context.state.ParamCotisations["TabRevenusRacl"]?.[Annee]?.["RevenusRacl"] ?? 0
                              }
                              onChange={(e) => {
                                context.handleTableauRevenusRacl(index, Annee, e);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                              style={{
                                width: "180px",
                                marginRight: 18,
                              }}
                            />
                            <TextField
                              value={
                                context.state.ParamCotisations["TabRevenusRacd"]?.[Annee]?.["RevenusRacd"] ?? 0
                              }
                              onChange={(e) => {
                                context.handleTableauRevenusRacd(index, Annee, e);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                              style={{
                                width: "180px",
                                marginRight: 18,
                              }}
                            />
                            <span style={{ flex: 1 }}></span>
                          </li>
                        );
                      })}
                </ul>
              </>
            )}

            {context.state.RetraiteActivite === "SalarieIrcantec" && (
              <>
                <Row tpad>
                  <Column>
                    <DropDown
                      label="Statut"
                      value={context.state.ParamCotisations["StatutIrcantec"]}
                      onChange={context.handleParametrePeriode("StatutIrcantec")}
                      options={[
                        { value: "1_100", label: "Salarié" },
                        { value: "2_66", label: "Praticien hospitalier temps plein avec activité libérale" },
                        { value: "3_100", label: " Praticien hospitalier temps plein sans activité libérale" },
                        { value: "4_100", label: "Praticien attaché et praticien attaché associé à temps plein" },
                        { value: "5_70", label: "Praticien attaché et praticien attaché associé à temps partiel" },
                        { value: "6_100", label: "Assistant des hôpitaux et assistant associé" },
                        { value: "7_100", label: "Praticien contractuel à temps plein" },
                        { value: "8_70", label: "Praticien contractuel à temps partiel" },
                      ]}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <div className="dossier-header">
                    <div className="dossier-header-icon">
                      <FaBuilding style={{ color: "#6b7280", fontSize: "16px" }} />
                    </div>
                    <span className="dossier-header-title">Cotisations retraite IRCANTEC (taux théoriques)</span>
                  </div>
                </Row>
                <Row tpad>
                  <div className="prise-en-charge-container">
                    <div className="prise-en-charge-table-container">
                      <table className="mono">
                        <tbody>
                          <tr>
                            <td></td>
                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                              <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                Salarié
                              </label>
                            </td>
                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                              <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                Patronale
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: "middle", marginBottom: 0 }}>
                              <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                Tranche A
                              </label>
                            </td>
                            <td>
                              <TextField
                                value={context.state.ParamCotisations["IrcantecT1Sal"]}
                                onChange={context.handleParametrePeriode("IrcantecT1Sal")}
                                dataType="ufloat"
                                format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                normal
                                style={{ textAlign: "center" }}
                              />
                            </td>
                            <td>
                              <TextField
                                value={context.state.ParamCotisations["IrcantecT1Pat"]}
                                onChange={context.handleParametrePeriode("IrcantecT1Pat")}
                                dataType="ufloat"
                                format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                normal
                                style={{ textAlign: "center" }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: "middle", marginBottom: 0 }}>
                              <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                Tranche B
                              </label>
                            </td>
                            <td>
                              <TextField
                                value={context.state.ParamCotisations["IrcantecT2Sal"]}
                                onChange={context.handleParametrePeriode("IrcantecT2Sal")}
                                dataType="ufloat"
                                format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                normal
                                style={{ textAlign: "center" }}
                              />
                            </td>
                            <td>
                              <TextField
                                value={context.state.ParamCotisations["IrcantecT2Pat"]}
                                onChange={context.handleParametrePeriode("IrcantecT2Pat")}
                                dataType="ufloat"
                                format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                normal
                                style={{ textAlign: "center" }}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Row>
              </>
            )}
            {context.state.RetraiteActivite === "TrimSpecifique" && (
              <>
                <Column>
                  <Row tpad>
                    <DropDown
                      label="Validation des trimestres"
                      value={context.state.ParamCotisations["OptionTrimSpecifique"]}
                      onChange={context.handleParametrePeriode("OptionTrimSpecifique")}
                      options={[
                        { value: "option1", label: "Taux de pension" },
                        { value: "option2", label: "Taux de pension + durée d'assurance" },
                      ]}
                      normal
                    />
                  </Row>
                  <Row tpad>
                    <DropDown
                      label="Nature des trimestres"
                      value={context.state.ParamCotisations["TypeTrimSpecifique"]}
                      onChange={context.handleParametrePeriode("TypeTrimSpecifique")}
                      options={[
                        { value: "assimile", label: "Assimilé" },
                        { value: "cotise", label: "Cotisé" },
                      ]}
                      normal
                    />
                  </Row>
                </Column>
              </>
            )}
            {context.state.RetraiteActivite === "Cavamac" && (
              <>
                {/* Column headers for the list */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: 700,
                    margin: "8px 0 8px 0",
                    paddingLeft: 12,
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    fontSize: 12,
                    color: "#64748b",
                    fontWeight: 600,
                    letterSpacing: "-0.01em",
                  }}
                >
                  <span style={{ minWidth: 96, marginRight: 18, textAlign: "center" }}>Année</span>
                  <span style={{ width: 180, marginRight: 18, textAlign: "center", display: "inline-block" }}>Commissions brutes</span>
                </div>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    width: "50%",
                    maxWidth: 700,
                    marginLeft: 0,
                    marginRight: 0,
                    display: "block",
                  }}
                >
                  {Object.keys(context.state.DetailRetraiteFutur).length > 0 &&
                    Object.keys(context.state.DetailRetraiteFutur)
                      .filter((Annee) => Number(Annee) >= context.state["TableauPoints" + props.ClientConjoint].AnneeFinCavamacComp)
                      .map((Annee, index) => {
                        return (
                          <li
                            key={"Cavamac" + index}
                            style={{
                              background: "#fff",
                              borderRadius: "12px",
                              boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                              padding: "8px 0 8px 12px",
                              marginBottom: "14px",
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                              border: "1.5px solid #d1d5db",
                              transition: "box-shadow 0.2s",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: 700,
                                fontSize: "12px",
                                color: " #6366f1",
                                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                                minWidth: 70,
                                marginRight: 18,
                                background: "#f1f5ff",
                                border: "1.5px solid #6366f1",
                                borderRadius: "8px",
                                padding: "4px 12px",
                                display: "inline-block",
                                textAlign: "center",
                              }}
                            >
                              {Annee}
                            </span>
                            <TextField
                              value={
                                Boolean(context.state.ParamCotisations["TabCommissionBruteCavamac"][Annee])
                                  ? context.state.ParamCotisations["TabCommissionBruteCavamac"][Annee]["CommissionBrute"]
                                  : 0
                              }
                              onChange={(e) => {
                                context.handleTableauCommission(index, Annee, e);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                              style={{
                                width: "180px",
                                marginRight: 18,
                              }}
                            />
                            <span style={{ flex: 1 }}></span>
                          </li>
                        );
                      })}
                </ul>
              </>
            )}
            {context.state.RetraiteActivite === "Carpv" && (
              <Row tpad>
                <Column>
                  <DropDown
                    label="Classe retraite"
                    value={context.state.ParamCotisations["classe_retraiteCarpv"]}
                    onChange={context.handleParametrePeriode("classe_retraiteCarpv")}
                    options={classe_retraiteCarpv}
                    normal
                  />
                </Column>
              </Row>
            )}

            {(context.state.RetraiteActivite === "Cnbf" || context.state.RetraiteActivite === "CnbfSalarie") && Number(context.state.RetraiteFinActivite.slice(4)) >= 2021 && (
              <Row tpad>
                <Column>
                  <DropDown
                    label="Classe retraite"
                    value={context.state.ParamCotisations["ClasseRetraiteCnbf"]}
                    onChange={context.handleParametrePeriode("ClasseRetraiteCnbf")}
                    options={ClasseRetraiteCnbf}
                    normal
                  />
                </Column>
              </Row>
            )}
            {/* {context.state.RetraiteActivite === "Cipav" && (
              <Row>
                <DropDown
                  label="Classe retraite jusqu'au 31/12/2022"
                  value={context.state.ParamCotisations["ClasseRetr"]}
                  onChange={context.handleParametrePeriode("ClasseRetr")}
                  options={ClasseRetr}
                  normal
                />
              </Row>
            )} */}
            {context.state.RetraiteActivite === "Cavec" && (
              <Row>
                <DropDown label="Classe retraite" value={context.state.ParamCotisations["ClasseRetr"]} onChange={context.handleParametrePeriode("ClasseRetr")} options={ClasseRetr} normal />
              </Row>
            )}
            {context.state.RetraiteActivite === "CavecSalarie" && (
              <>
                <Row tpad>
                  <CardBoxHeader icon={<FaDollarSign />}>
                    <span>Cotisations CAVEC</span>
                  </CardBoxHeader>
                </Row>
                <Row tpad>
                  <DropDown
                    label="Classe retraite"
                    value={context.state.ParamCotisations["CavecSalarie"]}
                    onChange={context.handleParametrePeriode("CavecSalarie")}
                    options={[
                      { value: "C", label: "C" },
                      { value: "D", label: "D" },
                    ]}
                    normal
                  />
                </Row>
              </>
            )}
            {context.state.RetraiteActivite === "Crn" && (
              <>
                <Column>
                  <Row tpad>
                    <Column>
                      <DropDown
                        label="Classe retraite section B"
                        value={context.state.ParamCotisations["ClasseRetraiteCrn"]}
                        onChange={context.handleParametrePeriode("ClasseRetraiteCrn")}
                        options={[
                          { value: "NC", label: "NC" },
                          { value: "1", label: "1" },
                          { value: "2", label: "2" },
                          { value: "3", label: "3" },
                          { value: "4", label: "4" },
                          { value: "5", label: "5" },
                          { value: "6", label: "6" },
                          { value: "7", label: "7" },
                          { value: "8", label: "8" },
                        ]}
                        normal
                      />
                    </Column>
                  </Row>
                  <Row tpad>
                    <Column>
                      <DropDown
                        label="Prestation de serment avant 2014"
                        labelStyle={{ width: "260px" }}
                        value={context.state.ParamCotisations["CrnSermentAvt2014"]}
                        onChange={context.handleParametrePeriode("CrnSermentAvt2014")}
                        options={[
                          {
                            value: false,
                            label: "Non",
                          },
                          {
                            value: true,
                            label: "Oui",
                          },
                        ]}
                        normal
                      />
                    </Column>
                    <Column>
                      <DropDown
                        hpad
                        label="Régime de Colmar et Metz"
                        value={context.state.ParamCotisations["CrnColmarMetz"]}
                        onChange={context.handleParametrePeriode("CrnColmarMetz")}
                        options={[
                          {
                            value: false,
                            label: "Non",
                          },
                          {
                            value: true,
                            label: "Oui",
                          },
                        ]}
                        normal
                      />
                    </Column>
                  </Row>
                  {/* Column headers for the list */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      maxWidth: 700,
                      margin: "8px 0 8px 0",
                      paddingLeft: 12,
                      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                      fontSize: 13,
                      color: "#64748b",
                      fontWeight: 600,
                      letterSpacing: "-0.01em",
                    }}
                  >
                    <span style={{ minWidth: 96, marginRight: 18, textAlign: "center" }}>Année</span>
                    <span style={{ width: 180, marginRight: 18, textAlign: "center", display: "inline-block" }}>Moyenne des produits</span>
                  </div>
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      width: "50%",
                      maxWidth: 700,
                      marginLeft: "8px",
                      marginRight: 0,
                      display: "block",
                    }}
                  >
                    {Object.keys(context.state.DetailRetraiteFutur).length > 0 &&
                      Object.keys(context.state.DetailRetraiteFutur).map((Annee, index) => {
                        return (
                          <li
                            key={"Crn" + index}
                            style={{
                              background: "#fff",
                              borderRadius: "12px",
                              boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                              padding: "8px 0 8px 12px",
                              marginBottom: "14px",
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                              border: "1.5px solid #d1d5db",
                              transition: "box-shadow 0.2s",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: 700,
                                fontSize: "12px",
                                color: " #6366f1",
                                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                                minWidth: 70,
                                marginRight: 18,
                                background: "#f1f5ff",
                                border: "1.5px solid #6366f1",
                                borderRadius: "8px",
                                padding: "4px 12px",
                                display: "inline-block",
                                textAlign: "center",
                              }}
                            >
                              {Annee}
                            </span>
                            <TextField
                              value={
                                Boolean(context.state.ParamCotisations["TabMoyenneProduitEtudeCrn"][Annee])
                                  ? context.state.ParamCotisations["TabMoyenneProduitEtudeCrn"][Annee]["MoyenneProduit"]
                                  : 0
                              }
                              onChange={(e) => {
                                context.handleTableauMoyenneProduit(index, Annee, e);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                              style={{
                                width: "180px",
                                marginRight: 18,
                              }}
                            />
                            <span style={{ flex: 1 }}></span>
                          </li>
                        );
                      })}
                  </ul>
                </Column>
              </>
            )}
            {context.state.RetraiteActivite === "RsiCommercant" && (
              <>
                <Column>
                  <Row tpad>
                    <DropDown
                      label="Affiliation RAVGDT"
                      value={context.state.ParamCotisations["Ravgdt"]}
                      onChange={context.handleParametrePeriode("Ravgdt")}
                      options={[
                        { value: "Non", label: "Non" },
                        { value: "Oui", label: "Oui" },
                      ]}
                      normal
                    />
                  </Row>

                  {context.state.ParamCotisations["Ravgdt"] === "Oui" && (
                    <Row tpad>
                      <TextField
                        label="Remises brutes corrigées"
                        value={context.state.ParamCotisations["RavgdtRemises"]}
                        onChange={context.handleParametrePeriode("RavgdtRemises")}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        normal
                      />
                    </Row>
                  )}
                </Column>
              </>
            )}
            {context.state.RetraiteActivite === "Chomage" && (
              <>
                <Row tpad>
                  <Column>
                    <DropDown
                      label="Cotisations AGIRC-ARRCO"
                      value={context.state.ParamCotisations["ChomageAgirArrco"]}
                      onChange={context.handleParametrePeriode("ChomageAgirArrco")}
                      options={[
                        { value: "Non", label: "Non" },
                        { value: "Oui", label: "Oui" },
                      ]}
                      normal
                    />
                  </Column>
                </Row>

                {context.state.ParamCotisations["ChomageAgirArrco"] === "Oui" && (
                  <Row tpad>
                    <Column>
                      <TextField
                        label="Salaire journalier de référence "
                        value={context.state.ParamCotisations["ChomageSJR"]}
                        onChange={context.handleParametrePeriode("ChomageSJR")}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        normal
                      />
                    </Column>
                  </Row>
                )}
              </>
            )}
            {(context.state.RetraiteActivite === "Maladie" || context.state.RetraiteActivite === "Invalidite") &&
              AnneeFinPeriode >= Number(context.state["TableauPoints" + props.ClientConjoint].AnneeFinAgircArrco + 1) && (
                <>
                  <Row tpad>
                    <DropDown
                      label="Affiliation AGIRC-ARRCO"
                      value={context.state.ParamCotisations["MaladieInvalAgircArrco"]}
                      onChange={context.handleParametrePeriode("MaladieInvalAgircArrco")}
                      options={[
                        { value: "Non", label: "Non" },
                        { value: "Oui", label: "Oui" },
                      ]}
                      normal
                    />
                  </Row>
                  {context.state.ParamCotisations["MaladieInvalAgircArrco"] === "Oui" && (
                    <Row tpad>
                      <TextField
                        label={"Moyenne journalière des points n-1"}
                        value={context.state.ParamCotisations["MaladieInvalPoints"]}
                        onChange={context.handleParametrePeriode("MaladieInvalPoints")}
                        dataType="ufloat"
                        format={{ thousands: " ", decimal: ",", precision: 4 }}
                        normal
                      />
                      <Column style={{ paddingTop: "28px" }} lpad>
                        <CustomTooltip
                          style={{ width: "500px", textAlign: "justify", padding: "14px" }}
                          type="info"
                          content={`
                                      ✨  Les points de retraite sont calculés sur la base des droits obtenus au cours de l’année n-1 qui précède l’année n pendant laquelle l’interruption de travail intervient. La caisse de retraite calcule la moyenne journalière des points de retraite en divisant le nombre de points obtenus au cours de l’année n-1 par 365.
                                      
                                      Exemple : Si le nombre de points de l’année N-1 est de 100, la moyenne journalière à saisir est de 0,2739 (100/365).
                                      
                                      En cas de période incomplète, la moyenne journalière est calculée en divisant le nombre de points de n-1 par le nombre de jours pendant lesquels ces points ont été acquis.
                                      
                                      Exemple : Si le nombre de points de l’année N-1 est de 100 et que la période N-1 correspond à 180 jours, le nombre de points à saisir est de 0,555 (100/180).
                                    `}
                        >
                          <Button
                            icon
                            {...createStyledButton("card-action", "cardEdit", {
                              backgroundColor: "#dbeafe",
                              padding: "6px",
                              minWidth: "28px",
                              width: "44px",
                              height: "28px",
                            })}
                          >
                            <FaQuestionCircle style={{ color: "#3b82f6", fontSize: "14px" }} />
                          </Button>
                        </CustomTooltip>
                      </Column>
                    </Row>
                  )}
                </>
              )}
            {(context.state.RetraiteActivite === "Carcdsf" || context.state.RetraiteActivite === "Carcdsf2" || context.state.RetraiteActivite === "Carpimko") && (
              <>
                <Column>
                  <Row tpad>
                    <DropDown
                      label="Conventionné"
                      value={context.state.ParamCotisations["Conventionne"]}
                      onChange={context.handleParametrePeriode("Conventionne")}
                      options={Conventionne}
                      normal
                    />
                  </Row>
                  {context.state.ParamCotisations["Conventionne"] === "oui" && (
                    <Row tpad>
                      <TextField
                        value={context.state.ParamCotisations["TauxCpam"]}
                        onChange={context.handleParametrePeriode("TauxCpam")}
                        label="Taux de prise en charge CPAM"
                        dataType="ufloat"
                        format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                        normal
                      />
                    </Row>
                  )}
                </Column>
              </>
            )}
            {context.state.RetraiteActivite === "Carmf" && (
              <>
                <Column>
                  <Row tpad>
                    <DropDown
                      label="Conventionné"
                      value={context.state.ParamCotisations["ConventionneCarmf"]}
                      onChange={context.handleParametrePeriode("ConventionneCarmf")}
                      options={ConventionneCarmf}
                      normal
                    />
                  </Row>
                  {context.state.ParamCotisations["ConventionneCarmf"] !== "non" && (
                    <Row tpad>
                      <TextField
                        value={context.state.ParamCotisations["TauxCpam"]}
                        onChange={context.handleParametrePeriode("TauxCpam")}
                        label="Taux de prise en charge CPAM"
                        dataType="ufloat"
                        format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                        normal
                      />
                    </Row>
                  )}
                </Column>
              </>
            )}
            {context.state.RetraiteActivite === "Cavp" && (
              <>
                <Column>
                  <Row tpad>
                    <DropDown
                      label="Biologiste conventionné"
                      value={context.state.ParamCotisations["BiologisteConventionne"]}
                      onChange={context.handleParametrePeriode("BiologisteConventionne")}
                      options={BiologisteConventionne}
                      normal
                    />
                  </Row>
                  <Row tpad>
                    <DropDown
                      label="Classe retraite"
                      value={context.state.ParamCotisations["CotisationCapi"]}
                      onChange={context.handleParametrePeriode("CotisationCapi")}
                      options={CotisationCapi}
                      normal
                    />
                  </Row>
                  <Row tpad>
                    <CardBoxHeader icon={<FaUserTie />}>
                      <span>Paramètres du régime par capitalisation</span>
                    </CardBoxHeader>
                  </Row>
                  <Row tpad>
                    <Column>
                      <TextField
                        label="Taux de rendement capi"
                        value={context.state[props.Outil + "TauxRendementCapi" + props.ClientConjoint]}
                        onChange={context.handleInputChange("TauxRendementCapi" + props.ClientConjoint)}
                        dataType="ufloat"
                        format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                        normal
                      />
                    </Column>
                    <Column>
                      <TextField
                        label="Taux de conversion capi"
                        value={context.state[props.Outil + "TauxConversionCapi" + props.ClientConjoint]}
                        onChange={context.handleInputChange("TauxConversionCapi" + props.ClientConjoint)}
                        dataType="ufloat"
                        format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                        normal
                      />
                    </Column>
                  </Row>
                </Column>
              </>
            )}
            {context.state.RetraiteActivite === "FonctionPublique" && (
              <>
                <Row tpad>
                  <CardBoxHeader icon={<FaUserTie />}>
                    <span>Carrière</span>
                  </CardBoxHeader>
                </Row>
                <Row tpad>
                  <Column>
                    <DropDown
                      label="Catégorie"
                      value={context.state[props.Outil + "CategorieFonctionPublique" + props.ClientConjoint]}
                      onChange={context.handleInputChange("CategorieFonctionPublique" + props.ClientConjoint)}
                      options={CategorieFonctionPublique}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <Column>
                    <CheckBox
                      label="Limite d'âge personnalisée"
                      before
                      inline
                      checked={true}
                      unchecked={false}
                      value={context.state[props.Outil + "LimiteAgePerso" + props.ClientConjoint]}
                      onChange={context.handleCheckChange("LimiteAgePerso" + props.ClientConjoint)}
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <Column>
                    <TextField
                      label="Année"
                      value={context.state[props.Outil + "LimiteAgeAgePerso" + props.ClientConjoint]}
                      onChange={context.handleInputChange("LimiteAgeAgePerso" + props.ClientConjoint)}
                      disabled={context.state["LimiteAgePerso" + props.ClientConjoint] === true ? false : true}
                      dataType="uint"
                      format={{ thousands: " ", unit: " ans" }}
                      normal
                      placeholder="65 ans"
                    />
                  </Column>
                  <Column lpad>
                    <TextField
                      label="Mois"
                      value={context.state[props.Outil + "LimiteAgeMoisPerso" + props.ClientConjoint]}
                      onChange={context.handleInputChange("LimiteAgeMoisPerso" + props.ClientConjoint)}
                      disabled={context.state["LimiteAgePerso" + props.ClientConjoint] === true ? false : true}
                      dataType="uint"
                      format={{ thousands: " ", unit: " mois" }}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <CardBoxHeader icon={<FaCalendarPlus />}>
                    <span>Majoration de trimestres</span>
                  </CardBoxHeader>
                </Row>
                <Row tpad>
                  <Column>
                    <TextField
                      label="Bonification (hors majoration enfant)"
                      labelStyle={{ width: "250px" }}
                      value={context.state[props.Outil + "Bonification" + props.ClientConjoint]}
                      onChange={context.handleInputChange("Bonification" + props.ClientConjoint)}
                      dataType="uint"
                      normal
                    />
                  </Column>
                  <Column lpad>
                    <TextField
                      label="MDA fonction publique hospitalière"
                      labelStyle={{ width: "250px" }}
                      value={context.state[props.Outil + "MDA" + props.ClientConjoint]}
                      onChange={context.handleInputChange("MDA" + props.ClientConjoint)}
                      dataType="uint"
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <CardBoxHeader icon={<FaDollarSign />}>
                    <span>Rémunération</span>
                  </CardBoxHeader>
                </Row>
                <Row tpad>
                  <Column>
                    <CheckBox
                      label="Indice majoré de fin de carrière"
                      before
                      inline
                      checked={true}
                      unchecked={false}
                      value={context.state[props.Outil + "IndiceMajorePerso" + props.ClientConjoint]}
                      onChange={context.handleCheckChange("IndiceMajorePerso" + props.ClientConjoint)}
                      style={{ marginBottom: "0px", paddingTop: "6px" }}
                    />
                  </Column>
                  <Column>
                    <TextField
                      value={context.state[props.Outil + "IndiceMajoreValeur" + props.ClientConjoint]}
                      onChange={context.handleInputChange("IndiceMajoreValeur" + props.ClientConjoint)}
                      disabled={context.state[props.Outil + "IndiceMajorePerso" + props.ClientConjoint] === true ? false : true}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <Column>
                    <DropDown
                      label="Assiette de la RAFP"
                      value={context.state[props.Outil + "AssietteRafp" + props.ClientConjoint]}
                      onChange={context.handleInputChange("AssietteRafp" + props.ClientConjoint)}
                      options={[
                        { value: "pourcentage", label: "% du traitement brut" },
                        { value: "forfaitaire", label: "Forfaitaire" },
                      ]}
                      normal
                    />
                  </Column>
                </Row>
                {context.state.AssietteRafp === "pourcentage" ? (
                  <Row>
                    <Column>
                      <TextField
                        label="Taux"
                        value={context.state[props.Outil + "TauxPrimeRAFP" + props.ClientConjoint]}
                        onChange={context.handleInputChange("TauxPrimeRAFP" + props.ClientConjoint)}
                        dataType="ufloat"
                        format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                        normal
                      />
                    </Column>
                  </Row>
                ) : (
                  <Row>
                    <Column>
                      <TextField
                        label="Montant"
                        value={context.state[props.Outil + "MontantPrimeRAFP" + props.ClientConjoint]}
                        onChange={context.handleInputChange("MontantPrimeRAFP" + props.ClientConjoint)}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        normal
                      />
                    </Column>
                  </Row>
                )}
              </>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
}
export default Parametres;
